"use client";
import React, { useState } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Box, Card, CardContent, IconButton } from "@mui/material";
import { AppImage, AppTextField, AppTextarea } from "@/common";
import { CloseIcon } from "@/icons";
import { DefaultModalGalaxyType } from "@/models";

const SortableItem = <T extends DefaultModalGalaxyType>({
  data,
  id,
  onDeleteImage = () => {},
  onEditTitle,
  index,
}: SortableItemProps<T>) => {
  const {
    isDragging,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: id });

  const [error, setError] = useState(false);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition || undefined,
    opacity: isDragging ? "0.5" : "1",
    transformOrigin: "50% 50%",
    height: "100%",
    width: "100%",
    borderRadius: "12px",
    cursor: isDragging ? "grabbing" : "grab",
    backgroundColor: "#ffffff",
  };
  return (
    <Card
      ref={setNodeRef}
      sx={{
        borderRadius: "12px",
        "& .MuiCardContent-root:last-child": {
          paddingBottom: "12px",
        },
      }}
      style={style}
      {...attributes}
    >
      <Box
        className="relative col-span-1 bg-center bg-cover rounded-3"
        sx={{
          backgroundImage: `url(${data?.url})`,
        }}
      >
        <AppImage
          {...listeners}
          width={"100%"}
          height={269}
          layout="fill"
          src={data?.url}
          objectFit="contain"
          boxProps={{
            sx: {
              borderRadius: "12px 12px 0 0",
              backdropFilter: "blur(10px)",
            },
          }}
          alt=""
        />
        <IconButton
          className="border border-border bg-white text-secondary text-[12px] absolute top-[10px] right-[10px] hover:bg-white"
          onClick={onDeleteImage}
        >
          <CloseIcon />
        </IconButton>
      </Box>
      <CardContent>
        <AppTextarea
          label="Nhập tên ảnh"
          defaultValue={data.name}
          onChange={(event) => {
            setError(
              event.target.value.length > ALBUM_RULES.title.maxLength.value
            );
          }}
          maxRows={3}
          height="50px"
          onBlur={(event) => {
            if (index !== undefined) onEditTitle(index, event.target.value);
          }}
          error={error}
          helperText={error ? ALBUM_RULES.title.maxLength.message : ""}
        />
      </CardContent>
    </Card>
  );
};

export default SortableItem;

export const ALBUM_RULES = {
  title: {
    maxLength: {
      value: 255,
      message: "Tên ảnh không vượt quá 255 ký tự",
    },
  },
};
type SortableItemProps<T> = {
  data: T;
  id: number | string;
  onDeleteImage?: () => void;
  onEditTitle: (index: number, value: string) => void;
  index?: number;
};
